/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeBasedOnCriteriaDto } from '../models';
// @ts-ignore
import type { EmployeeSearchCriteriaDto } from '../models';
// @ts-ignore
import type { GetSearchStateDto } from '../models';
// @ts-ignore
import type { InitEmployeeSearchDto } from '../models';
/**
 * EmployeeSearchApi - axios parameter creator
 * @export
 */
export const EmployeeSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get employee search state
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSearchState: async (searchId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('getEmployeeSearchState', 'searchId', searchId)
            const localVarPath = `/api/v1/employees/search/{searchId}/state`
                .replace(`{${"searchId"}}`, encodeURIComponent(String(searchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get employees
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees: async (searchId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchId' is not null or undefined
            assertParamExists('getEmployees', 'searchId', searchId)
            const localVarPath = `/api/v1/employees/search/{searchId}`
                .replace(`{${"searchId"}}`, encodeURIComponent(String(searchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init employee search
         * @param {EmployeeSearchCriteriaDto} employeeSearchCriteriaDto Employee search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initEmployeesSearch: async (employeeSearchCriteriaDto: EmployeeSearchCriteriaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeSearchCriteriaDto' is not null or undefined
            assertParamExists('initEmployeesSearch', 'employeeSearchCriteriaDto', employeeSearchCriteriaDto)
            const localVarPath = `/api/v1/employees/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employeeSearchCriteriaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeSearchApi - functional programming interface
 * @export
 */
export const EmployeeSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get employee search state
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeSearchState(searchId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSearchStateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeSearchState(searchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSearchApi.getEmployeeSearchState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get employees
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployees(searchId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeBasedOnCriteriaDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployees(searchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSearchApi.getEmployees']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Init employee search
         * @param {EmployeeSearchCriteriaDto} employeeSearchCriteriaDto Employee search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initEmployeesSearch(employeeSearchCriteriaDto: EmployeeSearchCriteriaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitEmployeeSearchDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initEmployeesSearch(employeeSearchCriteriaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeSearchApi.initEmployeesSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeSearchApi - factory interface
 * @export
 */
export const EmployeeSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeSearchApiFp(configuration)
    return {
        /**
         * 
         * @summary Get employee search state
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeSearchState(searchId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSearchStateDto> {
            return localVarFp.getEmployeeSearchState(searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get employees
         * @param {string} searchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployees(searchId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeBasedOnCriteriaDto> {
            return localVarFp.getEmployees(searchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init employee search
         * @param {EmployeeSearchCriteriaDto} employeeSearchCriteriaDto Employee search criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initEmployeesSearch(employeeSearchCriteriaDto: EmployeeSearchCriteriaDto, options?: RawAxiosRequestConfig): AxiosPromise<InitEmployeeSearchDto> {
            return localVarFp.initEmployeesSearch(employeeSearchCriteriaDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeSearchApi - interface
 * @export
 * @interface EmployeeSearchApi
 */
export interface EmployeeSearchApiInterface {
    /**
     * 
     * @summary Get employee search state
     * @param {string} searchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApiInterface
     */
    getEmployeeSearchState(searchId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSearchStateDto>;

    /**
     * 
     * @summary Get employees
     * @param {string} searchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApiInterface
     */
    getEmployees(searchId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeBasedOnCriteriaDto>;

    /**
     * 
     * @summary Init employee search
     * @param {EmployeeSearchCriteriaDto} employeeSearchCriteriaDto Employee search criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApiInterface
     */
    initEmployeesSearch(employeeSearchCriteriaDto: EmployeeSearchCriteriaDto, options?: RawAxiosRequestConfig): AxiosPromise<InitEmployeeSearchDto>;

}

/**
 * EmployeeSearchApi - object-oriented interface
 * @export
 * @class EmployeeSearchApi
 * @extends {BaseAPI}
 */
export class EmployeeSearchApi extends BaseAPI implements EmployeeSearchApiInterface {
    /**
     * 
     * @summary Get employee search state
     * @param {string} searchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApi
     */
    public getEmployeeSearchState(searchId: string, options?: RawAxiosRequestConfig) {
        return EmployeeSearchApiFp(this.configuration).getEmployeeSearchState(searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get employees
     * @param {string} searchId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApi
     */
    public getEmployees(searchId: string, options?: RawAxiosRequestConfig) {
        return EmployeeSearchApiFp(this.configuration).getEmployees(searchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init employee search
     * @param {EmployeeSearchCriteriaDto} employeeSearchCriteriaDto Employee search criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeSearchApi
     */
    public initEmployeesSearch(employeeSearchCriteriaDto: EmployeeSearchCriteriaDto, options?: RawAxiosRequestConfig) {
        return EmployeeSearchApiFp(this.configuration).initEmployeesSearch(employeeSearchCriteriaDto, options).then((request) => request(this.axios, this.basePath));
    }
}

